@import "../../../../shared/styles/base";

.questionWrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 1rem;
}

.questionTitle {
  color: $ds-neutral-700;
  margin-bottom: 0.75rem;
}

.redactableReportAnswer {
  display: flex;
  align-items: flex-start;

  .reportAnswer {
    flex: 1 1 auto;
  }

  .c-button {
    flex: 0 1 auto;
    margin-left: 1rem;
  }
}

.reportAnswer {
  height: auto;
  cursor: text;
  border-radius: 0.25rem;
  color: $ds-violet-900;
  display: flex;

  &__text {
    white-space: pre-line;
    flex-grow: 1;
    overflow-wrap: anywhere;

    &.removed {
      text-decoration: line-through $ds-violet-900;
    }
  }

  &__textSeparator {
    padding: 0 0.5rem;
  }

  &__badges {
    margin-left: 0.5em;
    position: relative;
    top: 0.075rem;
  }
}

.imageQuestion {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 1rem;
}

.imageQuestionWithRedaction {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 0.5rem 1rem;
}

.imageContainer {
  width: 130px;
}

.image {
  width: 130px;
  height: 130px;
  object-fit: cover;
}

.externalLink[target="_blank"]::after {
  display: none;
}

.answersWrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 1rem;
}

.reportAnswers {
  .answerWrapper:not(:last-child) {
    margin-bottom: 0.5rem;
  }
}

.answerWrapper {
  display: flex;
}

.reportAnswerIcon {
  border-radius: 3px;
  background-color: $ds-neutral-100;
  min-width: 20px;
  min-height: 20px;
  margin-right: 0.75rem;
  margin-top: 0.125rem;

  &.circular {
    border-radius: 50%;
  }

  path {
    fill: $ds-neutral-600;
  }
}

@media print {
  body:has(.reportContainer) {
    visibility: hidden;
  }

  ::after {
    visibility: hidden !important;
  }

  .print-report {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;

    .hidden-unless-print {
      visibility: visible;
      height: auto;
      padding-bottom: 1rem;
    }
  }

  svg {
    background-color: $ds-neutral-100 !important;
  }

  path {
    fill: $ds-neutral-600 !important;
  }
}
